let steps = [],
    currentStep,
    logger = document.getElementById('logger'),
    setupSDK = {
        appId: '12132321',
        appKey: '0cbfd82c',
        serverType: 'sandbox',
    },
    setupConfig = {
        fields: {
            number: {
                element: '#card-number',
                placeholder: '信用卡號',
            },
            expirationDate: {
                element: '#card-expirationDate',
                placeholder: '有效期限 MM/YY',
            },
            ccv: {
                element: '#card-ccv',
                placeholder: '背面末三碼',
            },
        },
        styles: {
            normal: {
                width: '100%',
                height: '40px',
                color: 'orange',
                borderColor: '#DDDDDD',
            },
            focus: {
                color: 'pink',
                borderColor: 'green',
            },
            error: {
                color: '#FF5353',
                borderColor: '#FF5353',
            },
            success: {
                color: '#000000',
                borderColor: '#DDDDDD',
            },
        },
    },
    setupCCVConfig = {
        fields: {
            ccv: {
                element: '#direct-ccv',
                placeholder: '背面末三碼',
            },
        },
        styles: {
            normal: {
                width: '100%',
                height: '60px',
                color: 'orange',
                borderColor: '#DDDDDD',
            },
            focus: {
                color: 'pink',
                borderColor: 'green',
            },
            error: {
                color: '#FF5353',
                borderColor: '#FF5353',
            },
            success: {
                color: '#000000',
                borderColor: '#DDDDDD',
            },
        },
    };

function initStep() {
    [].forEach.call(document.querySelectorAll('.step'), (step) => {
        steps.push(step);
    });
}
function changeStep(id) {
    if (!steps.length || steps[id] === undefined) return;

    steps.forEach((step, index) => {
        if (index === id) {
            currentStep = step;
            currentStep.classList.add('active');
            if (id === 0) initSetupSDK();
            if (id === 1) initCreditCard();
            if (id === 2) initCCV();
        } else {
            step.classList.remove('active');
        }
    });
}

function initSetupSDK() {
    const appIdField = currentStep.querySelector('#appId');
    appIdField.value = setupSDK.appId;

    const appKeyField = currentStep.querySelector('#appKey');
    appKeyField.value = setupSDK.appKey;

    const serverTypeField = currentStep.querySelector('#serverType');
    serverTypeField.value = setupSDK.serverType;

    const setupField = currentStep.querySelector('#setupField');
    setupField.value = JSON.stringify(setupConfig, undefined, 6);

    const setupCCVField = currentStep.querySelector('#setupCCVField');
    setupCCVField.value = JSON.stringify(setupCCVConfig, undefined, 6);

    const setupFieldBtn = currentStep.querySelector('#setupFieldBtn');
    setupFieldBtn.addEventListener('click', (e) => {
        setupSDK.appId = appIdField.value;
        setupSDK.appKey = appKeyField.value;

        window.PaymentSDK.setupSDK(
            setupSDK.appId,
            setupSDK.appKey,
            setupSDK.serverType
        );

        setupConfig = JSON.parse(setupField.value);
        changeStep(1);
    });

    const setupCCVBtn = currentStep.querySelector('#setupCCVBtn');
    setupCCVBtn.addEventListener('click', (e) => {
        setupSDK.appId = appIdField.value;
        setupSDK.appKey = appKeyField.value;

        window.PaymentSDK.setupSDK(
            setupSDK.appId,
            setupSDK.appKey,
            setupSDK.serverType
        );

        setupCCVConfig = JSON.parse(setupCCVField.value);
        changeStep(2);
    });
}

function initCreditCard() {
    const getTxnTokenBtn = currentStep.querySelector('#getTxnTokenBtn');
    getTxnTokenBtn.addEventListener('click', (e) => {
        window.PaymentSDK.card.getTxnToken((result) => {
            logger.innerHTML = JSON.stringify(result, null, 4);
        })
    });

    window.PaymentSDK.card.setup(setupConfig);
    window.PaymentSDK.card.onUpdate((result) => {
        logger.innerHTML = JSON.stringify(result, null, 4);
    })
    
}

function initCCV() {
    window.PaymentSDK.ccv.setup(setupCCVConfig);
    window.PaymentSDK.ccv.setupCardBrand(
        document.getElementById('cardBrand').value.toUpperCase()
    );
    window.PaymentSDK.ccv.onUpdate((result) => {
        logger.innerHTML = JSON.stringify(result, null, 4);
    });

    const getTxnLastTokenBtn = currentStep.querySelector('#getTxnLastTokenBtn');
    getTxnLastTokenBtn.addEventListener('click', (e) => {
        window.PaymentSDK.ccv.getTxnLastToken((result) => {
            logger.innerHTML = JSON.stringify(result, null, 4);
        });
    });
}

document.addEventListener('DOMContentLoaded', () => {
    initStep();
    changeStep(0);
});
